import { Button, TransparentButton } from '@libs/components';
import styled from 'styled-components';

export const Page = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.default};
  ${({ theme }) => theme.media.tabletL`
    background-color: transparent;
    margin-top: 2rem;
    height: unset;
  `}
`;
export const SwapButton = styled(TransparentButton)`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.low};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: 4px solid ${({ theme }) => theme.colors.surface.tertiary};
`;
export const SwapButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CurrencySelectInputWrapper = styled.div`
  margin-bottom: 0.4rem;
`;
export const Body = styled.div`
  padding: 2rem 1.6rem;
  ${({ theme }) => theme.media.tablet`
    padding: 2rem 3.6rem;
  `};
`;
export const SelectSearchWrapper = styled.div`
  padding: 3.4rem 3.4rem 2rem;
  min-width: 100%;
  ${({ theme }) => theme.media.tabletL`
    min-width:38rem;
  `}
`;
export const CustomButton = styled(Button)`
  margin-top: 2rem;
`;
export const DetailsBalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
